import {createSelector} from 'reselect';
import {getSelectedDeliveryOptionList} from '../DeliveryOptionsSelectors/DeliveryOptionsSelectors';

const getPaymentOptionsPermittedByDeliveryOption = createSelector(
  [getSelectedDeliveryOptionList],
  (deliveryOptionSelectedList) => {
    const permittedListWithDuplicates = deliveryOptionSelectedList
      ?.flatMap(selection => selection?.permittedPaymentOptions)
      .filter(result => result);
    
    return Array.from(new Set(permittedListWithDuplicates));
  },
);

export default getPaymentOptionsPermittedByDeliveryOption;
